<div class="card">
  <div class="card" style="display: flex; justify-content: space-between; align-items: center; padding: 0; border: none; background-color: transparent;">
    <div>
        <h4><strong style=" margin-left: 10px;">Invoice Receipt</strong></h4>
    </div>
    <div style="display: flex; margin-top: -10px;">
        <button pButton type="button" icon="pi pi-download" (click)="onClickExcel()" style=" background-color: #2c436b;" label="Excel Report"></button>
        <!-- <button pButton type="button" icon="pi pi-download" (click)="downloadPDF()" style="height: 10px; margin-right: 10px; background-color: #2c436b;" label="PDF Report"></button> -->
    </div>
  </div>
    <hr>
    <p-treeTable #tt [value]="mappedData" styleClass="p-treetable-gridlines" [columns]="cols"
        [rows]="10" [scrollable]="true" [scrollable]="true"  [tableStyle]="{ 'min-width': '135rem','min-height':'10px' }">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th style="width: 4rem; white-space: nowrap; text-align: center;">Action</th>
                <th>Vendor Code</th>
                <th>Status</th>
                <th>Invoice No</th>
                <th>Invoice Date</th>
                <th>IR No</th>
                <th>IR Date</th>
                <th>Net Value</th>
                <th>Tax Value</th>
                <th>Gross Value</th>
                <th>Vendor Name</th>
                <th>Partially Amount</th>
                <th>Balance Amount</th>
            </tr>
            <!-- <tr>
                <th class="text-center"></th>
                <th class="text-center">PO No</th>
                <th class="text-center">Line Item No</th>
                <th class="text-center">Material Code</th>
                <th class="text-center">Description</th>
                <th class="text-center">Quantity</th>
                <th class="text-center">Batch</th>
                <th class="text-center">UOM</th>
                <th class="text-center">Total</th>
                <th class="text-center">Tax Value</th>
                <th class="text-center">Gross Value</th>
                <th class="text-center">Net Value</th>
                <th class="text-center">IR Batch</th>
                <th class="text-center">IR Quantity</th>

            </tr> -->
            <tr>
                <th></th>
                <th *ngFor="let col of cols">
                  <!-- <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)"
                      [ngModel]="col.defaultFilter" /> -->
                      <ng-container *ngIf="col.field === 'ir_date' || col.field === 'invoice_date'; else textInput">
                        <input pInputText type="date" (change)="onInputChange($event, col.field)" placeholder="Select date..." />
                      </ng-container>
                      <ng-template #textInput>
                        <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)" />
                      </ng-template>
              </th>
            </tr>
        </ng-template>
        <!-- <ng-template pTemplate="caption">
            <div class="flex justify-content-end align-items-center">
                <div class="p-input-icon-left">
                    <i class="pi pi-search" style="font-size: 12px;"></i>
                    <input type="text" class="global-search" pInputText placeholder="Global Search"
                        (input)="onGlobalSearch($event)" />
                </div>
            </div>
        </ng-template> -->
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
            <tr [ttRow]="rowNode">
                <td style="width: 4rem; white-space: nowrap; text-align: center;">
                    <div style="display: flex; justify-content: center; align-items: center;">
                        <p-button *ngIf="rowNode.node.children"
                            tooltipPosition="top" icon="pi pi-eye" (click)="onClickGr(rowNode)" [rounded]="true"
                            [style]="{ 'margin-right': '.5em' }"></p-button>
                    </div>
                </td>
                <td *ngFor="let col of columns; let i = index; let last = last">
                    <div class="row">
                        <!-- <div class="column">
                            <p-button *ngIf="i === 0 && rowNode.node.children && rowNode.node.children.length > 0"
                                tooltipPosition="top" icon="pi pi-eye" (click)="onClickGr(rowNode)" [rounded]="true"
                                [style]="{ 'margin-right': '.5em' }"></p-button>
                        </div> -->
                        <div>
                            <!-- <p-treeTableToggler [rowNode]="rowNode" *ngIf="i === 0"></p-treeTableToggler> -->
                        </div>
                        <div *ngIf="col.field === 'payment_status'; else defaultField">
                            <span class="custom-tag" [ngClass]="getSeverityClass(getSeverity(rowData[col.field]))">
                                {{ rowData[col.field] }}
                            </span>
                        </div>
                        <ng-template #defaultField>
                            {{ rowData[col.field] }}
                        </ng-template>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-treeTable>
    <div>
        <p-paginator
            [rows]="limit"
            [first]="(currentPage - 1) * limit"
            [totalRecords]="totalRecords"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[10, 20,30,50,100]"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
       />
    </div>
</div>
<p-sidebar [(visible)]="sidebarVisible" position="right" [style]="{'width': '70%'}">
    <div class="row">
        <div class="column">
            <h5><strong>{{"IR No : " + irNo }}</strong></h5>
        </div>
        <div class="column">
            <div class="button-container">
                <button type="button" pButton pRipple icon="pi pi-file-excel" class="p-button-success mr-2"
                    pTooltip="XLS" tooltipPosition="bottom"
                    (click)="downloadExcel()"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" class="p-button-info mr-2" pTooltip="PDF"
                    tooltipPosition="bottom" (click)="exportPdf(selectedIrData,selectedPoData)"></button>
            </div>
        </div>
    </div> <br>
    <p-table #dt [value]="selectedIrData" styleClass="p-datatable-sm" selectionMode="multiple">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th>Vendor Code</th>
                <th>IR No</th>
                <th>Vendor Name</th>
                <th>IR Date</th>
                <th>IR Time</th>
                <th>Net Value</th>
                <th>Tax Value</th>
                <th>Gross Value</th>
                <th>Invoice No</th>
                <th>Invoice Date</th>
                <th>Business Place</th>
                <th>Status</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>{{rowData.vendor_code}}</td>
                <td>{{rowData.ir_no}}</td>
                <td>{{rowData.vendor_name}}</td>
                <td>{{rowData.ir_date}}</td>
                <!-- <td>{{rowData.payment_status}}</td> -->
                <td>{{rowData.ir_time}}</td>
                <td>{{rowData.net_value}}</td>
                <td>{{rowData.tax_value}}</td>
                <td>{{rowData.gross_value}}</td>
                <td>{{rowData.invoice_no}}</td>
                <td>{{rowData.invoice_date}}</td>
                <td>{{rowData.business_place}}</td>
                <td>
                    <span class="custom-tag" [ngClass]="getSeverityClass(getSeverity(rowData.payment_status))">
                        {{ rowData.payment_status }}
                    </span>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <h5><strong>{{"PO No : " + poNo }}</strong></h5><br>
    <p-table #dt [value]="selectedPoData" styleClass="p-datatable-sm" selectionMode="multiple">
        <ng-template pTemplate="header" let-columns>
            <tr>
              <!-- <th></th> -->
                <th>GR No</th>
                <th>PO No</th>
                <th>Line Item No</th>
                <th>Material Code</th>
                <th>Description</th>
                <th>UOM</th>
                <th>Total</th>
                <th>Tax Value</th>
                <th>Gross Value</th>
                <th>Net Value</th>
                <th>IR Batch</th>
                <th>IR Quantity</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>{{rowData.ir_no}}</td>
                <td>{{rowData.vendor_code}}</td>
                <td>{{rowData.vendor_name}}</td>
                <td>{{rowData.ir_date}}</td>
                <td>{{rowData.ir_time}}</td>
                <td>{{rowData.net_value}}</td>
                <td>{{rowData.tax_value}}</td>
                <td>{{rowData.gross_value}}</td>
                <td>{{rowData.invoice_no}}</td>
                <td>{{rowData.invoice_date}}</td>
                <td>{{rowData.business_place}}</td>
                <td>{{rowData.ir_quantity}}</td>
            </tr>
        </ng-template>
    </p-table>
</p-sidebar>
<p-dialog header="Header" [closable]="false" [(visible)]="isExcel" [modal]="true" [style]="{ width: '35rem'}"
[breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
<ng-template pTemplate="header">
    <!-- <div class="inline-flex align-items-center justify-content-center gap-2">
        <span class="font-bold white-space-nowrap">Select Date</span>
    </div> -->
</ng-template>
<ng-template pTemplate="footer">
    <p-button (click)="onCloseForExcelReport()" label="Close" pAutoFocus [autofocus]="true"></p-button>
    <p-button (click)="onDowunloadIrListByDate()" label="Download" pAutoFocus [autofocus]="true"
        [disabled]="!startDate || !endDate || dateValidation"></p-button>
</ng-template>
    <div class="grid">
        <div class="col">
            <label class="font-bold block mb-2"><strong>Start Date</strong><span class="required-asterisk">*</span></label>
            <div class="p-input-icon-left">
                <p-calendar [iconDisplay]="'input'" [showIcon]="true"
                    placeholder="Select Date" [(ngModel)]="startDate" appendTo="body" dateFormat="dd/mm/yy" [maxDate]="correctDate"
                    [showButtonBar]="true" (onSelect)="validateDate()" [required]="true"></p-calendar>
                <!-- <div *ngIf="dateValidation" class="text-red-500">Please select correct date</div> -->
            </div>
        </div>
        <div class="col">
            <label class="font-bold block mb-2"><strong>End Date</strong><span class="required-asterisk">*</span></label>
            <div class="p-input-icon-left">
                <p-calendar [iconDisplay]="'input'" [showIcon]="true"
                    placeholder="Select Date" appendTo="body" [(ngModel)]="endDate" dateFormat="dd/mm/yy" [maxDate]="correctDate"
                    [showButtonBar]="true" (onSelect)="validateDate()" [required]="true"></p-calendar>
                <!-- <div *ngIf="dateValidation" class="text-red-500">Please select correct date</div> -->
                <div *ngIf="endDate && startDate && endDate < startDate" class="text-red-500">End date cannot be before start date.</div>
                <div *ngIf="dateValidation && endDate && getDateDifference() > 4" class="text-red-500">The end date cannot be more than 4 months after the start date.</div>
            </div>
        </div>
    </div>
</p-dialog>
<div *ngIf="isLoading" class="loading-overlay">
  <app-loading-screen></app-loading-screen>
</div>
